import "./NewNoteButton.css";

function NewNoteButton(props: {onClick: () => void}): JSX.Element {
    return (
        <div className="newNoteButton" id="newNoteButton" onClick={props.onClick}>New 📒</div>    
    )
}

export default NewNoteButton;